/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-children-prop */
import React, { SyntheticEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  List,
  ListItem,
  ListItemText,
  Modal,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useStyles from '../../assets/styles/pages/SignUp';

// import svg
import { ReactComponent as IconArrow } from '../../assets/images/svg/sign_up/icon_seta_r.svg';
import { ReactComponent as IconEmail } from '../../assets/images/svg/sign_up/icon_email.svg';
import { ReactComponent as IconPassword } from '../../assets/images/svg/sign_up/icon_senha.svg';
import { ReactComponent as IconInfo } from '../../assets/images/svg/utils/info.svg';

import FooterMenuMain from '../../components/FooterMenuMain';
import { useLoadingContext } from '../../providers/use-loading';
import { useSignUpContext } from '../../providers/use-signup';
import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import Header from '../../components/Header';
import { removeStorege } from '../../helpers/db_storage';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: '10px 25px',
  outline: 'none',
};

const styleModalRecovePassword = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const SignUpEmail: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const { params, id_shop }: any = useParams();
  const { search } = useLocation();
  const variavelGet = new URLSearchParams(search);
  const getId = variavelGet.get('id');

  const { createloading } = useLoadingContext();
  const signUpContext = useSignUpContext();

  const [existUser, setExistUser] = useState<any>();
  const [typeRecovePw, setTypeRecovePw] = useState<string>('');
  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [openModalRecovePasswordSmsAndWp, setOpenModalRecovePasswordSmsAndWp] =
    useState(false);
  const [openModalRecoverPassword, setOpenModalRecoverPassword] =
    useState(false);
  const [modalText, setModalText] = useState({
    title: '',
    description: '',
  });
  const [formParams, setFormParams] = useState({
    dsEmail: '',
  });
  const [disableBtn, setDisableBtn] = useState(false);
  const [apiWhatsUse, setApiWhatsUse] = useState<boolean>(true);

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const handleChangeForm = (event: any) => {
    const { name } = event.target;
    const { value } = event.target;

    setFormParams((field) => {
      return {
        ...field,
        [`${name}`]: value,
      };
    });
  };

  const handleSubimt = async (event: SyntheticEvent) => {
    event.preventDefault();

    if (formParams.dsEmail === '') {
      setModalText({
        title: 'Atenção',
        description: 'Todas as informações são obrigatórias',
      });
      setOpenUserNotParams(true);
      return;
    }
    createloading(true);
    setDisableBtn(true);

    removeStorege('@mais/delivery/authorization/orders');

    try {
      const userData: ItypeReturnApi =
        await api.apiMaisdelivery.auth.getDataUser({
          nr_operacao: 39,
          dsEmail: formParams.dsEmail,
          nrDDD: 0,
          nrTelefone: 0,
          idUsuario_filtro: 0,
        });
      setDisableBtn(false);
      createloading(false);
      if (userData.data.length > 0) {
        setExistUser(userData.data);
        setOpenModalRecoverPassword(true);
        return;
      }
      signUpContext.setEmailStorage(formParams);
    } catch (error) {
      setDisableBtn(false);
      createloading(false);
      toast.error('Ocorreu erro ao validar o e-mail.');
    }
  };

  const handleRecovePassword = async (id: any, type: string) => {
    setOpenModalRecoverPassword(false);
    setOpenModalRecovePasswordSmsAndWp(false);
    let typeText = '';

    createloading(true);
    try {
      let userData: any;
      if (type === 'email') {
        typeText = 'e-mail';
        userData = await api.apiMaisdelivery.auth.recovePassword({
          nr_operacao: 42,
          idUsuario: id,
        });
      }

      if (type === 'sms') {
        typeText = 'SMS';
        userData = await api.apiMaisdelivery.auth.recovePassword({
          nr_operacao: 41,
          idUsuario: id,
        });
      }

      if (type === 'whatsapp') {
        typeText = 'WhatsApp';
        userData = await api.apiMaisdelivery.auth.recovePassword({
          nr_operacao: 40,
          idUsuario: id,
        });
      }

      createloading(false);
      if (userData.data.retorno === 'NOK') {
        toast.error(`Ocorreu erro ao enviar sua senha `);
        return;
      }
      setModalText({
        title: 'Informação',
        description: `Sua senha foi enviada via ${typeText}`,
      });
      setOpenUserNotParams(true);
      await new Promise((resolve) => {
        setTimeout(resolve, 3000);
      });
      handleToPage('/sign/in');
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu erro ao recuperar sua senha.');
    }
  };

  const handleModalRecovePasswordSmsAndWp = (type: string) => {
    setTypeRecovePw(type);
    setOpenModalRecoverPassword(false);
    setOpenModalRecovePasswordSmsAndWp(true);
  };

  const handleCheckApiToWhats = async () => {
    try {
      const result: any = await api.apiMaisdelivery.auth.recovePassword({
        nr_operacao: 70,
      });

      if (result.data.status === 'NOK') {
        setApiWhatsUse(false);
      }
    } catch (error) {
      toast.error('Ocorreu erro.');
    }
  };

  useEffect(() => {
    handleCheckApiToWhats();
  }, []);

  useEffect(() => {
    if (signUpContext.data.return === 'OK') {
      if (getId && !params && !id_shop) {
        handleToPage(`/sign/up/user/phone?id=${getId}`);
        return;
      }
      if (params && id_shop) {
        handleToPage(`/sign/up/user/phone/${params}/${id_shop}`);
        return;
      }
      handleToPage('/sign/up/user/phone');
    }
  }, [signUpContext.data.return]);

  useEffect(() => {
    if (signUpContext.data.msgError) {
      toast.error(signUpContext.data.msgError);
    }
  }, [signUpContext.data.msgError]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="SignUp" />
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          className={classeStyle.gridForm}
        >
          <form onSubmit={handleSubimt} className={classeStyle.form}>
            <Grid
              container
              item
              justifyContent="flex-start"
              alignItems="center"
              textAlign="center"
            >
              <label className={classeStyle.labelText}>
                Qual é seu melhor e-mail?
              </label>
              <IconEmail className={classeStyle.icon} />
              <input
                type="text"
                className={classeStyle.inputText}
                placeholder="exemplo@mail.com"
                name="dsEmail"
                value={formParams.dsEmail}
                onChange={handleChangeForm}
              />
            </Grid>
            <Grid
              container
              item
              justifyContent="center"
              alignItems="center"
              textAlign="center"
            >
              <Button
                className={classeStyle.btnSubmit}
                type="submit"
                variant="contained"
                disabled={disableBtn}
              >
                Continuar <IconArrow className={classeStyle.iconSave} />
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
      <FooterMenuMain />
      <Modal
        open={openUserNotParams}
        onClose={() => setOpenUserNotParams(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '520px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconInfo className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              {modalText.title}
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              {modalText.description}
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnModal}
            onClick={() => setOpenUserNotParams(false)}
            variant="contained"
          >
            Ok
          </Button>
        </Box>
      </Modal>
      <Modal
        open={openModalRecovePasswordSmsAndWp}
        onClose={() => setOpenModalRecovePasswordSmsAndWp(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalRecovePassword}>
          <Grid
            container
            item
            textAlign="center"
            justifyContent="center"
            xs={12}
            className={classeStyle.contentModal}
          >
            <h3 className={classeStyle.titleModalRv}>ESCOLHA O SEU NÚMERO</h3>
          </Grid>
          <Grid
            container
            item
            textAlign="center"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              sx={{
                width: '100%',
                height: 'auto',
              }}
            >
              <List
                sx={{
                  width: '100%',
                  bgcolor: 'background.paper',
                  position: 'relative',
                  overflow: 'auto',
                  maxHeight: 350,
                  border: ' solid 1px #dfd0d0',
                  borderBottomRightRadius: 10,
                  borderBottomLeftRadius: 10,
                  '& ul': { padding: 0 },
                }}
                subheader={<li />}
              >
                <li>
                  <ul>
                    <ListItem className={classeStyle.gridTitleSegund}>
                      <ListItemText
                        className={classeStyle.titleSegund}
                        primary="Seu número não está na lista? Mudou de número? Escolha a opção enviar por email."
                      />
                    </ListItem>
                  </ul>
                </li>
                {existUser?.map((data: any) => (
                  <li key={`${data.idUsuario}`}>
                    <ul>
                      <ListItem className={classeStyle.gridNameModal}>
                        <ListItemText
                          className={classeStyle.nameModal}
                          onClick={() =>
                            handleRecovePassword(data.idUsuario, typeRecovePw)
                          }
                          primary={`(${
                            data.nrDDD
                          }) 9XXXX-${data.nrTelefone.substring(5, 9)} `}
                        />
                      </ListItem>
                    </ul>
                  </li>
                ))}
              </List>
            </Box>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={openModalRecoverPassword}
        onClose={() => setOpenModalRecoverPassword(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...styleModal, height: '650px!important' }}>
          <Grid container item xs={12} justifyContent="center">
            <IconPassword className={classeStyle.iconModal} />
          </Grid>
          <Grid container item xs={12} justifyContent="center">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              className={classeStyle.titleModal}
              style={{ fontWeight: '550', width: '100%', textAlign: 'center' }}
            >
              JÁ EXISTE UMA CONTA COM ESTE E-MAIL!
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
              className={classeStyle.textModal}
            >
              Se você esqueceu sua senha escolha uma das opções abaixo para
              recuperar a sua senha.
            </Typography>
          </Grid>
          <Button
            className={classeStyle.btnModal}
            onClick={() =>
              handleRecovePassword(existUser[0].idUsuario, 'email')
            }
            variant="contained"
          >
            Enviar senha por E-mail
          </Button>
          {apiWhatsUse && (
            <Button
              className={classeStyle.btnModalSegund}
              onClick={() => handleModalRecovePasswordSmsAndWp('whatsapp')}
              variant="contained"
            >
              Enviar senha por WhatsApp
            </Button>
          )}
          <Button
            className={classeStyle.btnModalWhite}
            onClick={() => handleModalRecovePasswordSmsAndWp('sms')}
            variant="contained"
          >
            Enviar senha por SMS
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default SignUpEmail;
